import React from "react";
import { Phone, Mail } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingButtons = () => {
  return (
    <div className="fixed right-4 top-2/3 flex flex-col items-center gap-3 z-50">
      {/* Call Button */}
      <button
        className="w-12 h-12 bg-tan hover:bg-beige text-charcoal flex items-center justify-center rounded-lg shadow-lg border border-tan hover:border-beige transition-all duration-300 transform hover:scale-110"
        onClick={() => window.open('tel:+923333112200', '_self')}
        title="Call Us"
      >
        <Phone size={22} />
      </button>

      {/* WhatsApp Button */}
      <button
        className="w-12 h-12 bg-taupe hover:bg-darktaupe text-offwhite flex items-center justify-center rounded-lg shadow-lg border border-taupe hover:border-darktaupe transition-all duration-300 transform hover:scale-110"
        onClick={() => window.open('https://wa.me/923333112200', '_blank')}
        title="Message on WhatsApp"
      >
        <FaWhatsapp size={22} />
      </button>

      {/* Email Button */}
      <button
        className="w-12 h-12 bg-primary hover:bg-redburnt text-offwhite flex items-center justify-center rounded-lg shadow-lg border border-primary hover:border-redburnt transition-all duration-300 transform hover:scale-110"
        onClick={() => window.open('mailto:help@leatherhood.com', '_self')}
        title="Send Email"
      >
        <Mail size={22} />
      </button>
    </div>
  );
};

export default FloatingButtons;